import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
import moment from "moment";
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

export default class InvoicePaymentSearch extends BaseModel {
  sale_no = null;
  invoice_no = null;
  customer_uuid = null;
  min_amount = null;
  max_amount = null;
  invoice_type = null;
  date = null;
  payment_method = null;
  batch_id = null;
  bank_account = null;
  batch_status = null;
  reference_number = null;
  reconciled = null;
  payment_type = null;
  paymentDateRange = {startDate: null, endDate: null};
  buyer_group_account = null;
  branch_uuids = [];
  first_name = null;
  last_name = null;
  company_name = null;
  currency_uuid = null;


  attributeLabels = {
    sale_no: i18n.t('Sale'),
    invoice_no: i18n.t('Invoice'),
    customer_uuid: i18n.t('Customer'),
    min_amount: i18n.t('Min. Amount'),
    max_amount: i18n.t('Max. Amount'),
    invoice_type: i18n.t('Invoice Type'),
    date: i18n.t('Date'),
    payment_method: i18n.t('Payment Method'),
    batch_id: i18n.t('Batch ID'),
    bank_account: i18n.t('Bank Account'),
    batch_status: i18n.t('Batch Status'),
    reference_number: i18n.t('Reference Number'),
    reconciled: i18n.t('Reconciled'),
    buyer_group_account: i18n.t('Buyer Group Account'),
    branch_uuids: i18n.t('Branch'),
    first_name: i18n.t('First Name'),
    last_name: i18n.t('Last Name'),
    company_name: i18n.t('Company Name'),
    currency_uuid: i18n.t('Exchange Rate'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    delete data.customer;

    if (!this.reconciled) {
      delete data.reconciled;
    }

    if (this.paymentDateRange.startDate) {
      data.date_after = moment(this.paymentDateRange.startDate).format(SYSTEM_DATE_FORMAT);
      data.date_before = moment(this.paymentDateRange.endDate).format(SYSTEM_DATE_FORMAT);
    }
    data.branch_uuids = data.branch_uuids.join(',');

    delete data.paymentDateRange;

    return data;
  }

}
